export default __webpack_public_path__ + "static/media/gmail-logo.419fccf9.png";